import { render } from "./courses.vue?vue&type=template&id=1cb9bdc6&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"

import "./courses.vue?vue&type=style&index=0&id=1cb9bdc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb9bdc6"]])

export default __exports__